// Spain
export const locale = {
  lang: 'en',
  data: {
    TRANSLATOR: {
      SELECT: 'Elige tu idioma',
    },
    MENU: {
      NEW: 'nuevo',
      ACTIONS: 'Comportamiento',
      CREATE_POST: 'Crear nueva publicación',
      PAGES: 'Pages',
      FEATURES: 'Caracteristicas',
      APPS: 'Aplicaciones',
      DASHBOARD: 'INICIO',
      INSURANCE: 'POLIZAS',
      DOCUMENTS: 'CARGAR DOCUMENTOS',
      ACCOUNT_ESTATEMENTS: 'Informes',
      DOCUMENT_FORMS: "Descargar Formularios",
      PAYMENTS: 'PAGOS',
      CONTACTUS: 'CONTACTENOS',
      REPORTS: "INFORMES",
      REQUEST: "SOLICITUDES",
      QUOTES: "COTIZACIONES",
      H4FILTER: "FILTRO DE BÚSQUEDA",
      CLAIMS: "RECLAMOS",
      MCLAIMS: "RECLAMOS",
      UPLOAD_DOCUMENTS_POLICY : "CARGAR DOC'S DE POLIZA",
      SEND_DOCUMENTS_POLICY : "ENVIAR DOC'S POLIZA",
      QUOTER: "COTIZADOR",
      PAYMENT_REQUEST: "SOLICITUDES DE PAGO",
      QUOTES_CANCER: "COTIZADOR CANCER"
    },
    HOME: {
      WELCOME: 'Bienvenido',
      COMISIONXCOBRO: "Comisión por Cobro",
      PRIMASUSCRITO: "Prima Suscrito",
      COBRO: "Cobro",
      SINIESTROS_PAGADOS: "Siniestros Pagados",
      DESCRIPTIONS: "Descripcion",
      TOTAL: "Total"
    },
    MYPROFILE: {
        PROFILE: 'Mi Perfil',
        EDITPROFILE: 'Editar Perfil',
        UPDATEPROFILE: 'Actualizar Perfil',
        FIRSTNAME: 'Primer Nombre',
        SECONDNAME: 'Segundo Nombre',
        LASTNAME: 'Primer Apellido',
        SECONDLASTNAME: 'Segundo Apellido',
        CEDULA: "SSN",
        PERSONID: "SSN",
        RUC: "SSN / EIN",
        GROUP: "Grupo",
        AREA: "Sector de Mercado",
        EMAIL: "Correo",
        PHONE:"Teléfono",
        PHONE_OFFICE:"Teléfono de Oficina",
        PHONE_MOBILE: "Teléfono Móvil",
        ADDRESSES: "Direcciones",
        ADDRESS_TYPE : "Tipo de Dirección",
        ADDRESS: "Dirección",
        ADD_ADDRESS: "Agregar Dirección",
        LOADPROFILE: "Cargando perfil del usuario ...",
        UPDATEALERT: "Sus datos personales no estan completos, debe acualizar su SSN.  Presione para actualizar o cancelar."
    },
    CLAIMS: {
        NUM_CLAIM: "Nro. de Notificación",
        NOTIFYCLAIMS: "Notificar Reclamo",
        COMPLAINT: "Querella",
        LIST_CLAIMS: "Consultar Reclamos",
        LIST_CLAIM: "Consulta Reclamos",
        CREATE_CLAIMS: "Registrar Reclamos",
        CREATE_CLAIM: "Registrar Reclamo",
        BY_CLAIM_NUM: 'Nro. de Notificación',
        POLICE_FULLNAME: "Nombre Completo Policía",
        USED: "En Uso",
        ACCIDENT_DESCRIPTION: "Descripción del Accidente",
        INSURED_UNIT: "Unidad Asegurada",
        CLAIM_LOCATION: "Lugar del Accidente",
        TYPE_OF_INTEREST: "Tipo de Reclamacion",
        CAUSE_OF_INTEREST: "Causa Tipo Interés",
        REPORTED_BY: "Reportado Por",
        IS_INSURANCE: "Es Asegurado",
        INUSE: "En Uso",
        SUCCESS: "El reclamos se guardo de forma exitosa.",
        REQUIREDFILES: "Por favor cargar los documentos requeridos.",
        EMPTYDOCS: "No hay documentos requeridos."
    },
    DOCUMENTS: {
      HELP_1 : "Formatos de archivos permitidos: word, excel, pdf, jpg, png. Máximo hasta 20 MB.",
      TYPE: "Tipo de Documento",
      DOCUMENT: "Documento",
      DOCUMENTS: "Documentos",
      SELECT_FILE: "Seleccionar Archivo",
      CEDULA: "SSN",
      PASAPORTE: "Pasaporte",
      DOWNLOADBLES: "Descargables",
      UPLOAD_REQUIRED_DOCUMENTS: "Cargar Documentos",
      UPLOAD_REQUIRED_DOCUMENT: "Subir",
      REQUIRED_DOCUMENTS: "Documentos Requeridos",
      UPLOADLOADING: "Cargando documento ...",
      REQUIRED_DOCUMENTS2: "Debe seleccionar un documento para poder subirlo",
      REQUIRED_DOCUMENTS_LIFE: "Descargue los documentos requeridos para la emisión. Llenar y enviarlos.",
      UPLOAD_REQUIRED_DOCUMENTS_LIFE:"Suba los documentos que ha completado y firmado para su debido proceso de emisión.",
      UPLOAD_REQUIRED_DOCUMENTS_REQUEST:"Suba los documentos requeridos para procesar la solicitud.",
      FORM01: "Formulario conoce tu cliente",
      FORM02: "Formulario TC o ACH",
      FORM03: "Copia de SSN or Pasaporte",
      FORM04: "Modelo de carnet digital",
      FORM05: "Solicitud de vida",
      FORM06: "Cuestionario de Extranjero",
    },
    QUOTES: {
      QUOTES: "Cotizador",
      NEW: "Nuevo",
      QUOTESCZ: "Evaluación CZ Vida",
      QUOTESOFLIFE: "Cotizador de Vida",
      QUOTEID: "Nro.\nCotización",
      QUOTE: "Generar la cotización",
      PRINTDETAILS: "Imprimir Cotización",
      PRINT: "Imprimir",
      QUOTETOEMIT: "Enviar Solicitud",
      QUOTEVIEW: "Ver Cotización",
      QUOTEDETAILS: "Detalle de Cotización",
      QUOTESSENDAPPROVAL:"Enviar Ajuste de recargo",
      APPROVALPOLICIE: "Aprobar cotización y Emitir póliza",
      NEWQUOTE: "Nueva Cotización",
      ERROR1: "Hubo un error al procesar la cotización. Intente nuevamente.",
      REASONOFSURCHARGE: "Motivo de Recargo",
      HASPOLICIELIFE: "Cliente mantiene seguro de vida con Acerta",
      SELECT_STATUS: "Selecione el Estatus",

      QUOTES_CANCER: "Cotizador Cancer",
    },
    REQUEST: {
        TITLE: "Solicitudes",
        REQUEST: "Solicitud",
        REQUEST_NUM: "Nro. Solicitud",
        POLICY: "POLIZA",
        SELECT_PRODUCER:"Seleccione el Producer",
        SELECT_BRANCH: "Selecione el Branch",
        SELECT_STATUS: "Selecione el Estatus",
        STATUS: "Estatus",
        PRODUCER:"Agencia",
        BRANCH: "Branch",
        SELECT_CATEGORY: "Seleccione la Categoría",
        CATEGORY:"Categoría",
        SALE_EXECUTIVE: "Agente",
        CONTACT: "Contacto",
        POLICY_NUM: "Nro. Póliza",
        SELECT_POLICY_NUM: "Seleccione la Póliza",
        FINANCED: "Financed",
        BUSINESS_LINE: "Línea de Negocio",
        SELECT_BUSINESS_LINE: "Seleccione la Línea de Negocio",
        UNDERWRITING: "Underwriting",
        PROSPECT: "Prospecto",
        DAYS_PASSED: "Días",
        REQUEST_CREATED: "Vigencia Desde",
        REQUEST_CREATED_2: "Desde",
        REQUEST_DATEEND: "Vigencia Hasta",
        REQUEST_DATEEND_2: "Hasta",
        VIEW_STATUS: "Ver Estatus",
        TRACKING_PROCESS: "Traking Process",
        SUCCESS: "El reclamos se guardo de forma exitosa.",
        REQUIREDFILES: "Por favor cargar los documentos requeridos.",
        DOCUMENTS_UPLOADED: "Documentos cargados",
        DESCRIPTION: "Descripción",
        UPLOAD_DESCRIPTION: "Breve descripción del archivo",
        UPLOAD_DOCUMENTS : "Carga de documentos",
        ERROR_UPLOAD_DOCUMENT: "Error el documento no se pudo cargar. Intente nuevamente.",
        UPLOADING_DOCUMENT : "Cargando documento...",
        EMPTY_REQUIRED_FILES : "No hay documentos requeridos para cargar.",
        EMPTY_UPLOAED_FILES : "No hay documentos cargados.",
        SPECIAL_INSTRUCTION: "instrucciones especiales",
        REQUEST_DATECREATED: "Fecha Creación",
        FRECUENCY: "Frecuencia",
        PAYTO: "Pay to",
        PROCESS_REQUEST: "Procesar Solicitud",
        PROCESS_REQUEST_HELP: "Desea procesar la solicitud de póliza Nro. ",
        CREATE_TRACKING : "Nuevo traking ",
        TRACKINGS : "Traking",
        TRACKING : "Traking",
        TYPE_TRACKINGS : "Tipo de traking",
        TYPE_TRACKING : "Tipo de traking",
        DESCRIPTIONS2: "Observación",
        EMPTY_TRACKINGS: "No hay traking emitidos",
        ERROR_TRACKING: "Hubo un error, intente nuevamente o valide los campos requeridos.",
        ERROR_REQUEST: "Hubo un error, intente nuevamente o valide los campos requeridos.",
        PROCESS: "PROCESO",
        ID_MANAGER: "ID Operador",
        MANAGER: "Analista",
        DATEPAYTO: "Fecha Aplicación Pago"
    },
    REPORT: {
        REPORT_TYPE: "Tipo de Reporte",
        REPORT_LIST: "Lista de Reportes"
    },
    ACCOUNT_ESTATEMENTS: {
      ACCOUNT_ESTATEMENTS: "Informes",
    },
    GENERAL: {
      HI: "Hola",
      CONTACT: 'Contacto',
      CONTACTS: 'Contactos',
      CONTACT_INFO: "Información de los contactos", 
      LISTING_INSURANCE: 'Listado de Pólizas',
      LISTING_REQUEST: 'Listado de Solicitudes',
      LISTING_CLAIMS: "Listado de Reclamos",
      POLICY_VIEW: 'Consulta de Póliza',
      QUOTE_VIEW: "Consulta de Cotización",
      DOCUMENTS: 'Documentos',
      PAYMENTS: 'Pagos',
      CONTACTUS: 'Contactenos',
      DOWNLOAD: "Descargar",
      ACCOUNT_ESTATEMENTS: "Informes",
      ACCOUNT_ESTATEMENT: "Informes",
      DOCUMENT_FORMS: "Descargar Formularios",
      MONTHYEAR: "Mes y Año",
      REPORTS: "Informes",
      REPORTPRINT: "Imprimir",
      REPORT_SOLICITUDES: "Reporte de Solicitudes Pendientes o en Trámites  ",
      REPORT_CLAINS: "Reporte de Reclamos Pendientes de Daños y Salud",
      REPORT_SALESCOMISSION : "Reporte de Comisiones",
      REPORT_PAYMENTS : "Reporte de Pagos Aplicados",
      REPORT_INVOICES: "Reporte de Listado de Facturación",
      REPORT_DELINQUENCY: "Reporte de Listado de Morosidad",
      LOADING: "Procesando",
      FORGOTTEN_PASSWORD: "Olvidé mi contraseña",
      FORGOTTEN_PASSWORD_SUCCESS: "Información correcta.",
      FORGOTTEN_PASSWORD_SUCCESS_HELP: "Prontamente recibirá información para recuperar su contraseña.",
      FORGOTTEN_PASSWORD_HELP: "Ingrese su correo electrónico",
      FORGOTTEN_PASSWORD_ERROR: "La información ingresada es incorrecta.",
      EMPTY_QUERY: "No hay información para mostrar.",
      BY_DOCUMENT_NAME: "Nombre de documento",
      VIEWCLAIM : "Consulta de Reclamo",
      CREATE: "Nuevo",
      SEND_DOCUMENTS_POLICY2 : "Enviar documentos de poliza",
      
    },
    INPUT: {
      RETURN: "Regresar",
      SEND: "Enviar",
      SEND_POLICIE_EMAIL: "Los documentos serán enviados al correo del asegurado.",
      ERROR_SEND_POLICIES : "Hubo un problema para enviar los documentos. Intente Nuevamente.",
      EMPTY_SELECTED_POLICIES : "Debe seleccionar al menos una póliza.",
      PROCESS_SELECTION : "Procesar selección",
      PROCESS_POLICIE_SELECTION : "Procesar pólizas seleccionas",
      SELECT: "Seleccionar",
      CODE: "Código",
      VALIDATE_CODE: "Validar código",
      RESTART: "Reiniciar",
      OPTIONS: "Opciones",
      T: "-",
      COMPLAINT: "Querella",
      TYPE_LOGIN: "Tipo de Login",
      UPDATE: "Actualizar",
      ECONOMICGROUP: "Grupo Económico",
      SELECT_ECONOMICGROUP: "Seleccione Grupo Económico",
      DONTAPPLY: "No aplica",
      AGE: "Edad",
      AGE2: "Edad Cumplida",
      STATUS: "Estatus",
      CHANGE: "Cambiar",
      GENERATE: "Generar",
      RESET: "Limpiar",
      VIEW: "Consultar",
      COMPANIES: "Compañias",
      RETURN_TO_LIST: "Regresar",
      FILTER: 'Buscar',
      FILTER_BY: 'Buscar Por',
      BY_DESCRIPTION: 'Descripcion',
      BY_POLICY_NUM: 'Nro de Póliza',
      BY_STATUS: 'Por Estado',
      NUM_CERTIFICATE: "Nro De Certificado",
      DOWNLOAD: "Descargar",
      EDIT: "Editar",
      DELETE: "Eliminar",
      SUBMIT: "Enviar",
      CANCEL: "Cancelar",
      CLOSE: "Cerrar",
      ALL: 'Todo',
      EMAIL: 'Correo Electrónico',
      RELATIONSHIP: "Parentesco",
      CEDULA: "SSN",
      FULLNAME: 'Fullname',
      FIRSTNAME: 'Nombre',
      MIDDLENAME: 'Segundo Nombre',
      LASTNAME: 'Apellido',
      PHONE: 'Teléfono',
      SECONDLASTNAME: 'Segundo Apellido',
      PASSWORD: 'Password',
      CONFIRM_PASSWORD: 'Confirm Password',
      USERNAME: 'Usuario',
      REQUIRED: "Campo requerido",
      DATE: "Fecha",
      DATE_NOTIFICATION: "Fecha de Notificación",
      DATE_OCURENCE: "Fecha de Ocurrencia",
      AGENT: "Corredor",
      MONTH: "Mes",
      YEAR: "Año",
      SALESCOMISSION: "Comisión Poliza",
      AGENTCOMISSION: "Comisión Agente",
      GETENDOSO: "Solicitar Endoso",
      APPLY: "Aplicar",
      DATESTART: "Fecha Desde",
      DETEEND: "Fecha Hasta",
      DETAIL: "Detalle",
      ERROR_REQUIRED: "Por favor completar los campos requeridos",
      DENYPROCCESS: "La solicitud no se pudo procesar",
      INVOICE: "Factura",
      DATEP: "Fecha",
      DATEPAYMENT: "Fecha Pago",
      DATERECIPT: "Fecha Recibo",
      PERCENT: "Porcentaje",
      DOCUMENT_TYPE: "Tipo de Documento",
      DOWNLOAD_PDF: "Descargar PDF",
      DOWNLOAD_EXCEL: "Descargar Excel",
      DOWNLOAD_CSV: "Descargar CSV",
      CODCORREDOR: "Código de Corredor",
      ADDRESS: "Dirección",
      CITY: "Ciudad",
      STATE: "Estado",
      ZIP: "Código Postal",
      CREDITCARD: "Número de Tarjeta",
      CVV: "Código CVV",
      EXPIRATION_MONTH: "Mes",
      EXPIRATION_YEAR: "Año",
      PERSONID: "Identificación",
      CARID: "Tablilla",
      ENDOSOVIEW:"Solicitudes de endosos",
      BIRTHDATE: "Fecha de Nacimiento",
      GENDER: "Género",
      SMOKER: "Fumador",
      MOBILE: "Celular",
      PAYMENTTYPE:"Tipo de Pago",
      PAYMENTCYCLE: "Frecuencia de Pago",
      RECHARGE: "Recargo",
      OCURRENCEDATE: "Fecha",
      POSTALCODE2: "Código Postal 2",
      POSTALCODE: "Código Postal",
      CITYCLAIM: "Ciudad del Reclamo",
      COUNTRY: "País",
      SAVE: "Guardar",
      SEARCH_POLICIE: "Buscar póliza",
      SEARCH: "Buscar",
      BTN_SEARCH_DOCUMENTS: "Buscar archivo...",
      MAILING_LIST: "Lista de correos",
      PROCESS: "Procesar",

    },
    INSURANCE: {
      INSURED: 'Asegurado',
      PRODUCT: "Producto",
      INSUREDFULLNAME: 'Asegurado (Nombre Completo)',
      SUB_CATEGORY: "Producto",
      CATEGORY: 'Línea de Negocio',
      BY_STATUS: 'Por Estado',
      POLICY: "Póliza",
      POLICIES: "Pólizas",
      NUM_POLICY: "No. De Póliza",
      SELECT_POLICY: "Seleccionar Póliza",
      START_DATE: "Vigencia Desde",
      DUE_DATE: "Vigencia Hasta",
      COMPANY: "Aseguradora",
      OPTIONS: "Opciones",
      DEDUCIBLE: "Deducible",
      PRIMA: "Prima",
      PRIMAYEARLY: "Prima Anual",
      PRIMAMONTHLY: "Prima Mensual",
      SUMA_ASEGURADA_POLIZA: "Suma Asegurada Póliza",
      SUMA_ASEGURADA: "Suma Asegurada",
      SUMABR_ASEGURADA_INCENDIO: "Suma Asegurada<br> Incendio",
      SUMABR_ASEGURADA_CONTENIDO: "Suma Asegurada<br> Contenido",
      SUMA_ASEGURADA_INCENDIO: "Suma Asegurada Incendio",
      SUMA_ASEGURADA_CONTENIDO: "Suma Asegurada Contenido",
      LOCATION_OF_RISK: "Ubicación del riesgo",
      QUALIFICATION: "Porcentaje de clasificación",
      TERM: "Plazo cobertura años",
      DIVISA: "Moneda",
      INSURED_INTEREST: "Interes Asegurado",
      DOCUMENT: "Documento",
      DOCUMENT_NOMBRE: "Nombre Documento",
      DESCARGA: "Descarga",
      DEDUCTIBLE: "Deducible",
      COVERAGE: "Coverage",
      ACTIVE: "Activo",
      INACTIVE: "Inactivo",
      DESCRIPTION: "Descripción",
      UPLOAD_DESCRIPTION: "Breve descripción del archivo",
      NUM_CERTIFICATE: "Nro De Certificado",
      CERTIFICATE: "Certificado",
      UNITY: "Unidad",
      ENDOSOTYPE: "Tipo de Endoso",
      CATEGORYDETAIL: "Detalle por línea de negocio",
      TYPEOFRISK: "Tipo de Riesgo",
      STATUS: "Estatus",
      NO_DATA: "No hay resultados para mostrar.",
      AGENT:"Agente",
      REQUEST: "Solicitud",
      REQUEST_TYPE: "Tipo de Endoso",
      REQUEST_DATE: "Fecha Solicitud",
      R_DATE: "F. Solicitud",
      REQUEST_CREATED: "Fecha Aplicación",
      R_CREATED: "F. Aplicación",
      HIGH_DATE: "Fecha Inicio",
      LOW_DATE: "Fecha Exclusión",
      SURCHARGE: "Recargo Millar",
      SETPAYMENTYEARS: "Nro Años Pagos Prima",
      DETAILS: "Detalle",
      POLICY_GENERAL_CONDITION: "Ver Condiciones Generales",
      PAYTO: "Pay to",
      PAYMENT_FRECUENCY: "Frecuencia de Pago",
      DAYS_PASSED: "Días Transcurrido",
      DAYS: "día(s)",
      "QP01": "Prima Mensual Básica por Seguro de Vida",
      "QP02": "Recargo Mensual Por Agravación Riesgo",
      "QP03": "Prima Mensual Adicional por Seguro de Vida",
      "QP04": "Prima Mensual Básica por Beneficios Adicionales",
      "QP05": "Prima Mensual Total Nivelada a Pagar por plazo",
      "QP06": "Prima Anual a Pagar Nivelada Por el Plazo",
      "QP07": "Numero de Años Pago de Primas",
      "QP08": "Prima Anual a Pagar según años de Pago",
      "QP09": "Recargo Anual por Forma de Pago",

      "QP11": "Prima Anual Básica por Seguro de Vida",
      "QP12": "Recargo Por Agravación Riesgo",
      "QP13": "Prima Anual Adicional por Seguro de Vida",
      "QP14": "Prima Anual Básica por Beneficios Adicionales",
      "QP15": "Prima Anual Total Nivelada a Pagar por plazo",
      //"QP16": "Prima MENSUAL a Pagar Nivelada Por el Plazo",
      "QP16": "Prima a Pagar Nivelada Por el Plazo ",
      "QP17": "Numero de Años Pago de Primas",
      "QP18": "Prima Anual a Pagar según años de Pago",
     // "QP19": "Prima MENSUAL a Pagar según años de Pago",
     "QP19": "Prima a Pagar según años de Pago ",
      "QP20": "Recargo Anual por Forma de Pago"
    },
    PAYMENTS: {
      PROCESS_PAYMENT: "Procesar Pago",
      MAKE_PAYMENTS: "Realizar Pagos",
      BALANCE: "Saldo",
      DELINQUENCY: "Exigible",
      PAYMENT: "Pagar",
      DUE: "Monto a pagar",
      PANDDING_PAYMENT: "Pagos Pendientes",
      PAYMENT_ERROR: "Hubo un error al procesar el pago.",
      PAYMENT_PROCESS: "Su pago fue procesado satisfactoriamente.",
      PAYMENTMODE: "Modo de Pago",
      PAYMENTCYCLE: "Frecuencia",
      AMOUNTOFPAYMENTS: "Cantidad de Pagos",
      CUSTOM1_AMOUNT_ERROR: "El monto a pagar no puede ser mayor que la prima."
    },
    AUTH: {
      GENERAL: {
        OR: 'O',
        SUBMIT_BUTTON: 'Enviar',
        NO_ACCOUNT: 'No tienes una cuenta?',
        SIGNUP_BUTTON: 'Regístrate',
        FORGOT_BUTTON: 'Se te olvidó tu contraseña',
        BACK_BUTTON: 'Espalda',
        PRIVACY: 'Intimidad',
        LEGAL: 'Legal',
        CONTACT: 'Contacto',
        LISTING_INSURANCE: 'Listado de Pólizas',
        LISTING_QUOTES_LIFE: "Cotizaciones de Vida",
        DOCUMENTS: 'Documentos',
        PAYMENTS: 'Pagos',
        CONTACTUS: 'Contactenos',
        CODEPASSWORD: "Código de seguridad",
        CHANGEPASSWORD: "Cambiar la contraseña",
        USER_CREATE: "Crear un usuario",
        SUCCESS_USER_CREATE: "Se creo un nuevo usuario.",
        CREATE_USER_ERROR: "Hubo un error al crear el usuario. Es posible que el usuario ya exista."
      },
      LOGIN: {
          CODE: "Código",
        LOGIN: "Ingresar",
        TITLE: 'Crear una cuenta',
        BUTTON: 'Registrarse',
        WELCOME: "Bienvenidos",
        WELCOME_HELP: "Seleccione el tipo de login y escriba su usuario",
        SIGNIN_BUTTON: "Entrar",
        USERNAME: "Usuario",
        PASSWORD: "Contraseña",
        ENTER: "ENTRAR",
        ERROR: "Los datos suministrados son inválidos",
        FORGOT: 'Olvidé mi usuario',
        CLOSE_SESION: "Cerrar Sesión",
        NOTIFY: "Notificar"
      },
      FORGOT: {
        TITLE: 'Olvidé mi usuario',
        DESC: 'Ingrese su correo electrónico para restablecer',
        SUCCESS: 'Su cuenta se ha restablecido correctamente.',
      },
      CODEPASSWORD: {
        TITLE: 'Código de Verificación',
        FORGOTTEN_PASSWORD_HELP: 'Ingrese el código enviado a su correo electrónico',
        SUCCESS: 'Su contraseña de acceso se actualizo.',
        CODE_PASSWORD_ERROR: "El código de seguridad es inválido",
        REQUESTCHANGEPASSWORD: "Solicitar cambio de contraseña"
      },
      SUCCESSPASSWORD: {
        TITLE: 'Se actualizo la contraseña',
      },
      RESETPASSWORD: {
        TITLE: 'Olvidé mi contraseña',
        DESC: 'Ingrese la nueva contraseña',
      },
      REGISTER: {
        TITLE: '¿Aún no estás registrado?',
        DESC: 'CREAR CUENTA',
        CREATE_ACCOUNT: 'Crear Cuenta',
        SUCCESS_CREATE_ACCOUNT: 'Solicitud de registro de usuario safisfactorio.',
        SUCCESS: 'Su cuenta se ha registrado correctamente.',
        RETURN_LOGIN_PAGE: "Regresar al login",
        HELP_REGISTER: 'Introduzca los siguientes datos para registrarse.',
        HELP_SUCCESS_REGISTER: 'Su solicitud de registro de cuenta fue creada correctamente.',
        ERROR_1: "No se pudo enviar tu solicitud.  Intenta nuevamente.",
        ERROR_2: "La contraseña no coinciden",
        DOCUMENT_TYPE: "Tipo de Documento",
        NUM_DOCUMENT: "Número de documento",
        EMAIL: "EMAIL",
        PASSWORD: "Contraseña",
        REPEAT_PASSWORD: "Repetir Contraseña",
        ALL_READY_REGISTER: "¿Ya estás registrado?",
        CEDULA: "SSN",
        PASAPORTE: "Pasaporte",
        NROIDENTIFICACION: "Identificación",
        SELECT_ADDRESS: "Seleccione la dirección",
      },
      VALIDATION: {
        INVALID: '{{name}} is not valid',
        REQUIRED: '{{name}} is required',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Campo requerido',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
      }
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Selected records count: ',
        ALL: 'All',
        SUSPENDED: 'Suspended',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields'
      },
      ECOMMERCE: 'eCommerce',
      CUSTOMERS: {
        CUSTOMERS: 'Customers',
        CUSTOMERS_LIST: 'Customers list',
        NEW_CUSTOMER: 'New Customer',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Customer Delete',
          DESCRIPTION: 'Are you sure to permanently delete this customer?',
          WAIT_DESCRIPTION: 'Customer is deleting...',
          MESSAGE: 'Customer has been deleted'
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Customers Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected customers?',
          WAIT_DESCRIPTION: 'Customers are deleting...',
          MESSAGE: 'Selected customers have been deleted'
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected customers',
          MESSAGE: 'Selected customers status have successfully been updated'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Customer has been updated',
          ADD_MESSAGE: 'Customer has been created'
        }
      }
    }
  }
};
